<script lang="ts">
  import { useNodeViewContext } from '@prosemirror-adapter/svelte';

  const contentRef = useNodeViewContext('contentRef');
  const setAttrs = useNodeViewContext('setAttrs');
  const node = useNodeViewContext('node');
  const view = useNodeViewContext('view');
  const selected = useNodeViewContext('selected');

  const editable = view.props.editable?.(view.props.state) ?? false;

  type $$Props = {};
</script>

{#if editable}
  <a href={$node.attrs.src} title={$node.attrs.title} target="_blank" on:click|preventDefault>
    <img src={$node.attrs.src} alt={$node.attrs.alt} class:ProseMirror-selectednode={$selected} />
  </a>
{:else}
  <a href={$node.attrs.src} title={$node.attrs.title} target="_blank">
    <img src={$node.attrs.src} alt={$node.attrs.alt} />
  </a>
{/if}
